export const defaultColumns = [
  {label: 'Código', value: 'code'},
  {label: 'Nome', value: 'display_name'},
  {label: 'Ações', value: 'actions', className: 'w-9'},
]
